import React, { useEffect, useState } from 'react';

const SurveyPanel = ({ onContinueToCurrentSession }) => {
    const [surveyCompleted, setSurveyCompleted] = useState(false);

    useEffect(() => {
        const handlePostMessage = event => {
            if (event.data === 'surveyCompleted') {
                setSurveyCompleted(true);
            }
        };

        window.addEventListener('message', handlePostMessage);

        return () => {
            window.removeEventListener('message', handlePostMessage);
        };
    }, []);

    return (
        <div className='pre-session-container'>
            <h1 className="intro">Pre-Study Survey</h1>
            <div className='survey-panel' style={{ height: surveyCompleted ? '250px' : '500px' }}>
                <iframe
                    src="https://rotman.az1.qualtrics.com/jfe/form/SV_7VBy034DgVwoESi"
                    style={{ width: '100%', height: '100%', border: 'none' }}
                    title="Qualtrics Survey"
                ></iframe>
            </div>
            {surveyCompleted && (
                <button className="continue-button" onClick={onContinueToCurrentSession}>
                    Continue
                </button>
            )}
        </div>
    );
};

export default SurveyPanel;
